import { decode, encode } from 'base64-arraybuffer';

export const base64UrlToBuffer = (base64Url: string): ArrayBuffer => {
  const base64 = base64UrlToBase64(base64Url);
  const buffer = decode(base64);
  return buffer;
};

export const bufferToBase64Url = (buffer: ArrayBuffer): string => {
  const base64 = encode(buffer);
  const base64Url = base64ToBase64Url(base64);
  return base64Url;
};

export const base64ToBase64Url = (base64: string) => {
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
};

export const base64UrlToBase64 = (base64Url: string): string => {
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  // Pad out with standard base64 required padding characters
  const pad = base64.length % 4;
  if (pad) {
    if (pad === 1) {
      throw new Error(
        'Input base64url string is the wrong length to determine padding'
      );
    }
    base64 += new Array(5 - pad).join('=');
  }

  return base64;
};
